import { render, staticRenderFns } from "./base-bulk-message-list-item.vue?vue&type=template&id=379d1eba"
import script from "./base-bulk-message-list-item.vue?vue&type=script&lang=js"
export * from "./base-bulk-message-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379d1eba')) {
      api.createRecord('379d1eba', component.options)
    } else {
      api.reload('379d1eba', component.options)
    }
    module.hot.accept("./base-bulk-message-list-item.vue?vue&type=template&id=379d1eba", function () {
      api.rerender('379d1eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/base-bulk-message-list-item.vue"
export default component.exports